export enum TICKET_ACTION {
  WAITING_FOR_RESPONSE = 'Waiting for response',
  NEEDS_ATTENTION = 'Needs attention',
}
